import React, { useState, useEffect } from 'react';
import { Center, FlatList, Text } from 'native-base';
import PrivateMessage from './PrivateMessage';
import GoBackButton from '../content/common/GoBackButton';
import CreateMessageBox from './CreateMessageBox';
import { useAuthState } from '../../context/auth';
import { topicsAPI } from '../../context/topics';
const PrivateMessageScreen = _ref => {
  let {
    navigation,
    route
  } = _ref;
  const [privateMessages, setPrivateMessages] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [allowedUsers, setAllowedUsers] = useState([]);
  const {
    topicId: privateMessageId,
    name,
    username
  } = route.params;
  const authState = useAuthState();
  useEffect(() => {
    getPrivateMessages();
  }, [privateMessageId]);
  const getPrivateMessages = async () => {
    try {
      let response = {};
      if (privateMessageId) {
        var _response, _response$post_stream, _response2, _response2$details, _response3, _response3$details;
        response = await topicsAPI.getSingleTopic(envState.base_url, authState.api_key, privateMessageId);
        const sortedMessages = (_response = response) === null || _response === void 0 ? void 0 : (_response$post_stream = _response.post_stream) === null || _response$post_stream === void 0 ? void 0 : _response$post_stream.posts.sort((a, b) => Date(b.created_at) - Date(a.created_at));
        const participantsList = (_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$details = _response2.details) === null || _response2$details === void 0 ? void 0 : _response2$details.participants;
        const allowedUsersList = (_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$details = _response3.details) === null || _response3$details === void 0 ? void 0 : _response3$details.allowed_users;
        setPrivateMessages(sortedMessages);
        setParticipants(participantsList);
        setAllowedUsers(allowedUsersList);
      }
      return response;
    } catch (err) {
      console.log('Error while getting private messages');
      return {};
    }
  };
  const renderItem = _ref2 => {
    let {
      item: pmsg
    } = _ref2;
    return /*#__PURE__*/React.createElement(PrivateMessage, {
      pmsg: pmsg,
      key: pmsg.id
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GoBackButton, {
    navigation: navigation,
    my: 1
  }), /*#__PURE__*/React.createElement(Center, {
    w: '100%',
    h: '80%'
  }, privateMessageId && privateMessages && privateMessages.length > 0 ? /*#__PURE__*/React.createElement(FlatList, {
    data: privateMessages,
    renderItem: renderItem,
    keyExtractor: pmsg => pmsg.id.toString()
  }) : /*#__PURE__*/React.createElement(Text, null, "Start a conversation!")), /*#__PURE__*/React.createElement(CreateMessageBox, {
    topicId: privateMessageId,
    name: name,
    username: username,
    participants: participants && participants,
    allowedUsers: allowedUsers && allowedUsers
  }));
};
export default PrivateMessageScreen;
//# sourceMappingURL=PrivateMessageScreen.js.map